export enum CachingPrefix {
  TEST_DATA_PARAMETER_TESTDATA_CACHING_KEY = 'test-data-drawer-parameter-testdata',
  TEST_DATA_DATA_GENERATOR_FUNCTION_NAME_CACHING_KEY = 'testdata-data-generator-function-names',
  TEST_DATA_DATA_GENERATOR_KIBBUTZ_FUNCTION_NAME_CACHING_KEY = 'testdata-data-generator-kibbutz-function-name',
  TEST_DATA_DATA_GENERATOR_FUNCTION_CACHING_KEY = 'testdata-data-generator-functions',
  FETCH_USER_CACHING_KEY = 'fetch-user',
  FETCH_PROJECT_USERS_LIST = 'fetch-project-users-list',
  TEST_DATA_TEST_CASE_LINKING_TDP_CACHING_KEY = 'test-data-test-case-linking-tdp',
  FETCH_TESTDATA_RUNTIME = 'fetch-testdata-runtime',
  FETCH_RUNTIME_VARIABLE_USAGE = 'fetch-runtime-variable-usage',
  FETCH_ENVIRONMENT_VARIABLES = 'fetch-environment-variables',
  FETCH_TESTDATA_UPLOADS = 'fetch-testdata-uploads',
  UPLOADS_FETCH_VERSION = 'uploads-fetch-version',
  FETCH_STEP_GROUP = 'fetch-step-group',
  FETCH_ELEMENTS = 'fetch-elements',
  FETCH_TESTDATA_MAILBOX = 'fetch-testdata-mailbox',
  FETCH_TESTDATA_PHONENUMBER = 'fetch-testdata-phonenumber',
  ENVIRONMENT_VARIABLES_DATA = 'environment-variables-data',
  TESTPLAN_FIRST_PARENT_RESULT = 'testplan-first-parent-result',
  FETCH_EXPORT_BACKUP_LIST = 'fetch-export-backup-list',
  FETCH_IMPORT_BACKUP_LIST = 'fetch-import-backup-list',
  FETCH_AGENTS = 'fetch-agents',
  TESTCASE_LISTITEMS = 'testcase-listitems',
  SELECTED_TESTCASE = 'selected-testcase',
  SUITE_TEST_CASES_IDS = 'suite-test-cases-ids',
  LINKED_SUITE_TEST_CASES = 'linked-suite-test-cases',
  FIGMA_DEVICES = 'figma-image-step',
  FEATURES_AND_SCENARIOS = 'features-and-scenarios',
  FETCH_ARTEFACTS_FIND_ALL = 'fetch-artefacts-find-all',
  FETCH_LINKED_COUNT = 'fetch-linked-count',
  FETCH_LINKED_DATA_FIND_ALL = 'fetch-linked-data-find-all',
  FETCH_UNLINKED_DATA_FIND_ALL = 'fetch-unlinked-data-find-all',
  FETCH_ARTEFACTS_IMPORT_DATA_FIND_ALL = 'fetch-artefacts-import-data-find-all',
  ATTO_SESSIONS = 'atto-sessions',
}
